import { instanceUpload, errorService } from '@/services/api'
import { templateAPIs } from '@/services/authConstantsV1'
import _ from 'lodash'
import { AgGridVue } from 'ag-grid-vue'
import { getDimensions, showNotification } from '@/services/calculate'
import { socketEvents } from '@/services/config'

export default {
  components: {
    'ag-grid-vue': AgGridVue,
  },
  props: [
    'uploadedFile',
    'name',
    'columnDefs',
    'templateId',
    'buildingGeneralId',
  ],
  data: function() {
    return {
      visible: false,
      process: false,
      data: null,
      duration: 0,
      datafromSocket: null,
      processContent: `Your request for uploading ${this.name} will be processed shortly...`,
      updateList: [],
      selectedRowData: [],
      gridOptions: null,
      gridApi: null,
      defaultColDef: null,
      tableParams: null,
      width: '100%',
      height: '400px',
      loading: false,
      addedCount: 0,
      updatedCount: 0,
      failedCount: 0,
    }
  },
  created: function() {
    this.$root.$on('message-received', this.messageReceived)
  },
  beforeMount() {
    this.loadingConfig()
  },
  beforeDestroy() {
    this.$root.$off('message-received')
  },
  mounted() {
    this.importFile()
  },
  methods: {
    handleCancel() {
      this.visible = false
      this.duration = null
      this.selectedRowData = []
      this.displayNotification()
      this.$emit('clickedCancel', this.addedCount)
    },

    importFile() {
      this.$notification.info({
        message: 'Import Request',
        description: (
          <div>
            <div>
              Your request for importing {this.name} will be processed shortly.
            </div>
            <div>You will be notified once the request is completed</div>
          </div>
        ),
        duration: 5,
      })
      const formdata = new FormData()
      formdata.append('file', this.uploadedFile)
      const url = templateAPIs.buildingGeneral.tenant.importTenant(
        this.templateId,
        this.buildingGeneralId,
      )
      instanceUpload
        .post(url, formdata)
        .then(response => {
          this.$notification.destroy()
          if (response.data.message) {
            showNotification('info', 'Import', response.data.message)
          }
        })
        .catch(err => {
          errorService(err)
        })
    },

    saveData() {
      this.$emit('updateBulkTenant', this.selectedRowData)
    },

    onRowSelected(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data)
      this.selectedRowData = selectedData
    },

    onSelectionChanged(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data)
      this.selectedRowData = selectedData
    },

    getData(params) {
      this.selectedRowData = []
      this.gridApi = this.gridOptions.api
      params.api.setColumnDefs(this.columnDefs)
      params.api.sizeColumnsToFit()
      this.tableParams = params
      this.height = getDimensions(params, this.height, this.updateList)
    },

    loadingConfig() {
      this.gridOptions = {
        alwaysShowVerticalScroll: true,
        alwaysShowHorizontalScroll: true,
        headerHeight: 30,
        rowHeight: 28,
        suppressRowClickSelection: true,
        singleClickEdit: true,
        stopEditingWhenGridLosesFocus: true,
        rowSelection: 'multiple',
        defaultColDef: {
          sortable: false,
          suppressMovable: true,
        },
      }
    },

    displayNotification() {
      let description = null
      if (
        this.addedCount > 0 &&
        this.selectedRowData.length > 0 &&
        this.updatedCount > 0 &&
        this.failedCount === 0
      ) {
        description = `${this.name} is imported successfully. ${this.addedCount} new records added and ${this.updatedCount} records updated successfully.`
        showNotification('success', 'Import', description)
      }
      if (
        this.addedCount > 0 &&
        this.selectedRowData.length > 0 &&
        this.updatedCount > 0 &&
        this.failedCount > 0
      ) {
        description = `${this.name} is imported successfully. ${this.addedCount} new records added and ${this.updatedCount} records updated successfully.`
        showNotification('success', 'Import', description)
      }
      if (
        this.selectedRowData.length > 0 &&
        this.updatedCount > 0 &&
        this.failedCount === 0
      ) {
        description = `${this.name} is imported successfully. ${this.updatedCount} records updated successfully.`
        showNotification('success', 'Import', description)
      }
      if (
        this.selectedRowData.length > 0 &&
        this.updatedCount > 0 &&
        this.failedCount > 0
      ) {
        description = `${this.name} is imported successfully. ${this.updatedCount} records updated successfully. ${this.failedCount} records failed to update`
        showNotification('success', 'Import', description)
      }
      if (
        this.selectedRowData.length > 0 &&
        this.updatedCount === 0 &&
        this.failedCount > 0
      ) {
        description = `${this.failedCount} records failed to update`
        showNotification('success', 'Import', description)
      }
      if (this.addedCount > 0) {
        description = `${this.name} is imported successfully. ${this.addedCount} new records added successfully.`
        showNotification('success', 'Import', description)
      }
    },

    // Socket listen
    messageReceived: function(message) {
      this.loading = false
      this.$notification.destroy()
      const data = JSON.parse(message.message)
      if (data.EventType === socketEvents.error) {
        showNotification(
          'warning',
          'Import',
          _.get(data.Result, 'Message', ''),
        )
        this.$emit('updateTableData')
      }
      if (data.EventType === socketEvents.fileImported) {
        if (data.Status === 'SUCCESS') {
          this.updateList = []
          const list = _.get(data.Result, 'UpdateList', [])
          this.addedCount = _.get(data.Result, 'AddedCount', 0)
          if (list.length > 0) {
            list.forEach(element => {
              this.updateList.push({
                id: element.Id,
                tenantName: element.TenantName,
                suite: element.Suite,
                tenantTypeId: element.TenantTypeId,
                tenantType: element.TenantType,
                tenantSF: element.TenantSF,
              })
            })
            this.visible = true
          } else if (this.addedCount > 0) {
            this.$notification.success({
              message: 'Import',
              description: h => (
                <div>
                  <div>
                    <b>
                      {this.addedCount} / {data.Result.TotalCount}
                    </b>{' '}
                    {this.name.toLowerCase()}
                    {this.addedCount > 0 ? 's' : ''} added.
                  </div>
                </div>
              ),
              duration: 5,
            })
            this.$emit('updateTableData')
          } else {
            this.$notification.error({
              message: 'Import',
              description: h => (
                <div>
                  <div>
                  There was an error while importing the{' '}
                    {this.name.toLowerCase()}.
                  </div>
                  <div>No record added in the database.</div>
                  <div>Please try again.</div>
                </div>
              ),
            })
            this.$emit('updateTableData')
          }
          data.name = this.name
          this.$root.$emit('socketMessage', data)
        } else {
          showNotification(
            'warning',
            'Import',
            _.get(data.Result, 'Message', ''),
          )
        }
      } else if (data.EventType === socketEvents.templateSideBarUpdated) {
        this.$root.$emit('loadSidebar', message)
      } else if (data.EventType === socketEvents.error) {
        showNotification(
          'error',
          'Error',
          'There was an error while importing file. Please try again or contact administrator.',
        )
      }
    },
  },
}
